import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-label-email-preview',
  templateUrl: './label-email-preview.component.html',
  styleUrls: ['./label-email-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LabelEmailPreviewComponent {
  readonly email = input<string>('');
  readonly label = input<boolean>(false);
}
